import { Link, useLocation, useNavigate, useRouter } from '@tanstack/react-router';
import { objectTabs, useObjectTabs } from './objectTabs.ts';

/**
 * Tabs of the objects opened in this environment (BB-20), kept across reloads. Closing the tab being edited goes to
 * its list — with the unsaved-changes dialog when there are real changes.
 */
export function ObjectTabs({ environmentId }: { environmentId: string }) {
  const tabs = useObjectTabs(environmentId);
  const pathname = decodeURIComponent(useLocation().pathname);
  const isCurrent = (url: string) => pathname === decodeURIComponent(url);
  const navigate = useNavigate();
  const router = useRouter();
  if (tabs.length === 0) return null;
  const close = async (type: string, id: string, url: string, listUrl: string) => {
    if (isCurrent(url)) {
      await navigate({ to: listUrl });
      // Navigation stayed (Keep editing): keep the tab too.
      if (decodeURIComponent(router.state.location.pathname) === decodeURIComponent(url)) return;
    }
    objectTabs.close(environmentId, type, id);
  };
  return (
    <nav className="object-tabs" aria-label="Open objects">
      <ul>
        {tabs.map((t) => (
          <li key={`${t.type}:${t.id}`} className={isCurrent(t.url) ? 'object-tabs__tab object-tabs__tab--current' : 'object-tabs__tab'}>
            <Link to={t.url} aria-current={isCurrent(t.url) ? 'page' : undefined}>
              {t.title}
            </Link>
            <button type="button" className="icon-button" aria-label={`Close tab ${t.title}`} onClick={() => void close(t.type, t.id, t.url, t.listUrl)}>
              ×
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
